import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';

class OverlayOption extends React.Component{
    constructor() {
        super();
        this.sidebarChange = this.sidebarChange.bind(this);
        this.deleteLayerList = this.deleteLayerList.bind(this);
        this.gotoLayer = this.gotoLayer.bind(this);
        this.state = {
            opacity : "",
            helpMode : "None"
        };
    }    
    componentWillMount(){  
        const layerName = this.props.layer.layerName;
        const defaultOpacity = window.main.OView.getTerrainOverlay(layerName).opacity * 100;
        this.setState({opacity:defaultOpacity});
    }
    sidebarChange(event){
        const layerName = this.props.layer.layerName;
        window.main.OView.getTerrainOverlay(layerName).opacity = event.target.value/100;
        const defaultOpacity = window.main.OView.getTerrainOverlay(layerName).opacity * 100;
        this.setState({opacity:defaultOpacity});
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var Pos = new window.Geo3DPoint(121.2347878442796,23.427553934089445,465850.0013822634);
        var V = new window.Geo3DPoint(0,0,-1);
        var Up = new window.Geo3DPoint(0,1,0);
        var Camera = new window.ov.Camera(Pos,V,Up);
        window.main.OView.gotoCamera(Camera, true);
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const Layer = this.props.layer;
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        if(this.state.helpMode === "Layer2DHelp" ){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/Hgt-xaw9AX8" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts fourteen wide column"  >
                        <h6 className="layerNameCSS">{Layer.layerName}
                            <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("Layer2DHelp")}>
                                <i className="help small icon" style={{color:"#919191"}}></i>
                            </button>
                        </h6>
                    </div>                    
                    <label className="ts two wide column right aligned">{(this.state.opacity).toFixed(1)}%</label>
                </div>                
                <div>                    
                    <input type="range" min="0" max="100" defaultValue={this.state.opacity} step="1" onChange={(e)=>this.sidebarChange(e)} style={siderRangeCSS}></input>
                </div>
                <div className="ts grid">
                    <div className="ts two wide column" id="removeLayerIcon" onClick={(e)=>this.deleteLayerList(Layer)}>
                        <i className="remove circle outline icon"></i>
                    </div>
                    <div className="ts twelve wide column"></div>
                    <div className="ts two wide column" id="gotoLayerIcon" onClick={(e)=>this.gotoLayer()}>
                        <i className="marker icon"></i>
                    </div>
                </div>
            </div>
        );
    }
}

class OverlayLayer extends React.Component{
    constructor() {
        super();        
        this.state = {List:[]};
        this.wmtsLayerChecked = this.wmtsLayerChecked.bind(this);
    }
    componentWillMount(){
        var layerThis = this;
        const WMTSLayerList = window.LAYER_GROUP_2DWMTS.WMTS_LAYERS;
        window.LAYER_GROUP_2DWMTS.WMTS_GROUP.map(
            (layers) =>
            window.ov.getWMTSLayerInfo(layers.URL,function(e){
                if(e.url&&e.identifier){
                    WMTSLayerList.push({
                        TITLE:e.title||e.identifier,
                        TYPE:"Overlay",
                        ID:e.identifier,
                        URL:e.url,
                        CHECKED:false
                    });
                }
                layerThis.setState({List:WMTSLayerList});
            })
        )
    }
    componentDidUpdate(){
        const layerList = this.state.List;
        if(this.props.deleteList.layerType === "Overlay"){
            for (let i = 0, len = this.state.List.length; i < len; i++){
                if (layerList[i].TITLE === this.props.deleteList.layerName){
                    if(layerList[i].CHECKED){
                        layerList[i].CHECKED = !layerList[i].CHECKED;
                        window.main.OView.removeTerrainOverlay(layerList[i].TITLE);
                        window.alertify.error("已關閉圖層："+layerList[i].TITLE);                        
                        this.setState({List:layerList});
                        return ;
                    }
                }
            }
        }      
    }
    wmtsLayerChecked(layer,index){
        const list = this.state.List;
        const LayerEPSG = layer.EPSG || 3857;
        const layerThis = this;             
        if(!layer.CHECKED){
            if(this.props.LayerLength<15){
                if(layer.CLASS !== "SingleTile"){
                    window.main.OView.addTerrainWMTSOverlay({
                        url: layer.URL,
                        identifier: layer.ID,
                        layername: layer.TITLE,
                        pgmapserver: false,
                        epsg: LayerEPSG,
                        urlTemplate: "{URL}"
                    }, function (e) {
                        if(e){
                            window.alertify.success("已開啟圖層："+layer.TITLE);
                            layerThis.props.setOpenLayer(layer,null);                     
                            list[index].CHECKED = !layer.CHECKED;
                            layerThis.setState({List:list});
                        }
                        else if(!e){
                            window.alertify.error("開啟圖層失敗："+layer.TITLE);
                        }
                    });
                }
                else{
                    let param = {};
                    param.url = layer.URL;
                    param.layername = layer.TITLE;
                    param.boundary = new window.GeoBoundary(
                        layer.Boundary.West,
                        layer.Boundary.South,
                        layer.Boundary.East,
                        layer.Boundary.North
                    );

                    // 用加入的方式新增Single tile Overlay。
                    // ov.TerrainView.addTerrainSingleTileOverlay(settings, callback, index)
                    // @param {Object} settings 參數物件。
                    // @param {String} settings.url 要圖網址或base64編碼(data:image/png;base64,XXX)。
                    // @param {String} settings.layername Overlay名稱。
                    // @param {GeoBoundary} settings.boundary 圖層的範圍。
                    // @param {Number} [settings.opacity = 1] 圖層的不透明度，0~1。
                    // @param {Boolean} [settings.show = true] 圖層是否顯示。
                    // @param {ov.TerrainView~addTerrainSingleTileOverlayCallback} [callback] 執行新增疊加圖層後的回呼函式。
                    // @param {Number} [index] 插入索引，若沒有填值則視為加在最後面。
                    window.main.OView.addTerrainSingleTileOverlay(param);
                    window.alertify.success("已開啟圖層："+layer.TITLE);
                    layerThis.props.setOpenLayer(layer,null);                     
                    list[index].CHECKED = !layer.CHECKED;
                    layerThis.setState({List:list});
                }
                
            }
            else{
                window.alertify.error("為維持較好的使用效能，已達WMTS圖層開啟上限15張");
            }                     
        }
        else{
            window.main.OView.removeTerrainOverlay(layer.TITLE);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            list[index].CHECKED = !layer.CHECKED;    
            layerThis.setState({List:list});        
        }
                      
    }
    render(){
        const List =this.state.List;
        return( 
            <div className="ts checkboxes">
                {
                    List.map(
                        (layers,index)=>                    
                        <div className="ts checkbox" data-tooltip={layers.TITLE}>
                            <input type="checkbox" name="wmtslayers" id={layers.TITLE} onChange={(e)=>this.wmtsLayerChecked(layers,index)} checked={layers.CHECKED}></input>
                            <label htmlFor={layers.TITLE}>{layers.TITLE}</label>
                        </div>
                    )
                }
            </div>           
        );
    }
}

export {OverlayLayer,OverlayOption} ;